module.exports = __webpack_public_path__ + "static/media/secure.a633beca.jpeg";